import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Spin } from 'antd'
import { inject } from 'mobx-react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const GET_SETTINGS = gql`
    query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
    }
`

const MunicipalName = (props) => {
	const { 
		AuthStore, isUpperCase, ...rest 
	} = props
	const { barangay_uid=null } = AuthStore
	// const [isSaving, setSaving] = useState(false)

	return (
		<Query query={GET_SETTINGS} variables={{ barangay_uid, code: 'MUNICIPAL_NAME' }}>
			{({ loading, error, data }) => {
				if (loading) return <Spin/>
				const mSetting = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				const value = _.has(mSetting, 'value') ? mSetting.value : null
				return <span { ...rest }>{ isUpperCase ? value.toUpperCase() : value }</span>
			}}
		</Query>
	)
}

const composed = compose(
	inject('AuthStore')
)

export default composed(MunicipalName)